import './ControlPanel.css';

import React from 'react';
import { connect } from 'react-redux';

import MainPanel from '../components/MainPanel';

import {
  interfaceActions,
  buttonsActions,
} from '../../../common/redux/actions';
import Spinner from '../../../common/components/spinner/Spinner';
import { Result, Button } from 'antd';

const { getProfileButtons } = buttonsActions;
const { disableCaption } = interfaceActions;

class ControlPanel extends React.Component {
  state = {
    profileId: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.activeProfile.profileId !== prevState.profileId) {
      return { profileId: nextProps.activeProfile.profileId };
    } else return null;
  }

  componentDidMount() {
    this.props.disableCaption();
    this.props.getProfileButtons();
  }

  render() {
    const { ...props } = this.props;
    const { buttons } = props;

    return (
      <div className="panelWrapper">
        {buttons.isLoading && buttons.buttons.length === 0 ? (
          <Spinner />
        ) : (
          <div className="control-panel">
            {buttons.buttons && buttons.buttons.length > 0 ? (
              <MainPanel {...props} buttons={buttons.buttons} />
            ) : (
              <div style={{ backgroundColor: 'rgb(255, 255, 255)' }}>
                <Result
                  status="warning"
                  title="У Вас нет активных профилей"
                  extra={
                    <Button
                      type="primary"
                      onClick={() =>
                        this.props.history.push('/authorization/profiles')
                      }
                    >
                      Перейти к быбору профиля
                    </Button>
                  }
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  state => ({
    activeProfile: state.Authorization.activeProfile,
    buttons: state.Interface.buttons,
  }),
  {
    disableCaption,
    getProfileButtons,
  }
)(ControlPanel);
